import { api } from "../scripts/api.js";
// const TEST_USERS = [
//    { id: 1,  name: "David Brown",         nickname: "kudcbrown",    email: "kudcbrown@gmail.com",     classes: 2, role: "admin" },
//    { id: 2,  name: "David Clayton Brown", nickname: "DavidNickname", email: "dcbrown@arizona.edu",     classes: 0, role: "professor" },
//    { id: 3,  name: "Eric Kelley",         nickname: null,           email: "ekk@utk.edu",            classes: 0, role: "student" },
//    { id: 4,  name: "Joel M Hetland",      nickname: null,           email: "jhetland@arizona.edu",   classes: 0, role: "student" },
//    { id: 5,  name: "Luke E Bonaime",      nickname: null,           email: "lukebonaime@arizona.edu", classes: 0, role: "student" },
//    { id: 6,  name: "Phong Duong",         nickname: "dev",          email: "phongd28@arizona.edu",   classes: 3, role: "admin" },
//    { id: 7,  name: "Phong Duong",         nickname: "dev3",         email: "phongvn215@gmail.com",   classes: 1, role: "student" },
//    { id: 8,  name: "Maria Gonzalez",      nickname: "mgonz",        email: "mgonzalez@arizona.edu",  classes: 4, role: "professor" },
//    { id: 9,  name: "James Chen",          nickname: null,           email: "jchen@arizona.edu",      classes: 0, role: "student" },
//    { id: 10, name: "Sarah Kim",           nickname: "skim",         email: "sarahk@utk.edu",         classes: 2, role: "student" },
//    { id: 11, name: "Ahmed Hassan",        nickname: null,           email: "ahassan@arizona.edu",    classes: 1, role: "student" },
//    { id: 12, name: "Emily Rodriguez",     nickname: "em_rod",       email: "erodriguez@arizona.edu", classes: 5, role: "professor" },
//    { id: 13, name: "Michael O'Brien",     nickname: null,           email: "mobrien@arizona.edu",    classes: 0, role: "student" },
//    { id: 14, name: "Priya Patel",         nickname: "ppatel",       email: "ppatel@arizona.edu",     classes: 3, role: "student" },
//    { id: 15, name: "Tom Anderson",        nickname: null,           email: "tanderson@utk.edu",      classes: 0, role: "student" },
//    { id: 16, name: "Lisa Wang",           nickname: "lwang",        email: "lwang@arizona.edu",      classes: 2, role: "admin" },
//    { id: 17, name: "Carlos Mendoza",      nickname: null,           email: "cmendoza@arizona.edu",   classes: 1, role: "student" },
//    { id: 18, name: "Nina Volkov",         nickname: "nvolkov",      email: "nvolkov@arizona.edu",    classes: 0, role: "student" },
//    { id: 19, name: "Kevin Lee",           nickname: null,           email: "klee@arizona.edu",       classes: 4, role: "professor" },
//    { id: 20, name: "Rachel Green",        nickname: "rgreen",       email: "rgreen@utk.edu",         classes: 2, role: "student" },
//    { id: 21, name: "Daniel Foster",       nickname: null,           email: "dfoster@arizona.edu",    classes: 0, role: "student" },
//    { id: 22, name: "Sofia Martinez",      nickname: "smartinez",    email: "smartinez@arizona.edu",  classes: 3, role: "student" },
//    { id: 23, name: "William O'Connor III", nickname: null,          email: "woconnor@arizona.edu",   classes: 1, role: "student" },
//    { id: 24, name: "Yuki Tanaka",         nickname: "ytanaka",      email: "ytanaka@arizona.edu",    classes: 2, role: "professor" },
//    { id: 25, name: "Grace Nakamura",      nickname: null,           email: "gnakamura@utk.edu",      classes: 0, role: "student" },
// ];
class Roles extends HTMLElement {
   connectedCallback() {
      this.tab = "all";
      this.filter = "";
      this.users = [];
      this.requests = [];

      this.innerHTML = `
         <section class="roles">
            <header>
               <h1>Roles & Access</h1>
            </header>
            
            <div class="card">
               <div class="card-head">
                  <div class="role-tabs" role="group" aria-label="View">
                     <button type="button" class="tab-btn is-active" data-tab="all" aria-pressed="true">All users</button>
                     <button type="button" class="tab-btn" data-tab="waiting" aria-pressed="false">
                        Waiting list <span class="tab-count" hidden></span>
                     </button>
                  </div>

                  <input type="search" class="user-search" placeholder="Search name or email" autocomplete="off" />
               </div>

               <table class="user-table user-table--head">
                  <colgroup class="user-cols"></colgroup>
                  <thead class="table-head"></thead>
               </table>

               <div class="table-scroll">
                  <table class="user-table user-table--body">
                     <colgroup class="user-cols"></colgroup>
                     <tbody class="user-rows"></tbody>
                  </table>
               </div>
            </div>
         </section>
      `;

      this.tabsEl = this.querySelector(".role-tabs");
      this.headEl = this.querySelector(".table-head");
      this.rowsEl = this.querySelector(".user-rows");
      this.colEls = this.querySelectorAll(".user-cols");
      this.searchEl = this.querySelector(".user-search");
      this.countEl = this.querySelector(".tab-count");

      // --- Tab switching ---
      this.tabsEl.addEventListener("click", (e) => {
         const btn = e.target.closest(".tab-btn");
         if (!btn || btn.dataset.tab === this.tab) return;
         this.tab = btn.dataset.tab;
         this.tabsEl.querySelectorAll(".tab-btn").forEach((b) => {
            const active = b === btn;
            b.classList.toggle("is-active", active);
            b.setAttribute("aria-pressed", String(active));
         });
         this.switchTab();
      })

      // --- Search (All User tab only) ---
      this.searchEl.addEventListener("input", (e) => {
         this.filter = e.target.value.trim().toLowerCase();
         if (this.tab === "all") this.renderUsers();
      });

      // --- Row actions (delegated; both tabs share this tbody) ---
      this.rowsEl.addEventListener("click", (e) => {
         const saveBtn = e.target.closest("button[data-save]");
         if (saveBtn) this.saveRole(saveBtn.dataset.save, saveBtn);

         const approveBtn = e.target.closest("button[data-approve]");
         if (approveBtn) this.approve(approveBtn.dataset.approve, approveBtn);

         const denyBtn = e.target.closest("button[data-deny]");
         if (denyBtn) this.deny(denyBtn.dataset.deny, denyBtn);
      });

      this.rowsEl.addEventListener("change", (e) => {
         const sel = e.target.closest("select[data-role-for]");
         if (sel) {
            const user = this.users.find((u) => String(u.id) === sel.dataset.roleFor);
            if (user) {
               user.pendingRole = sel.value;
               this.renderUsers();
            }
         }
      });

      this.switchTab();
      this.refreshCount();
   }

   // Decide what to load/show for active tab
   switchTab() {
      if (this.tab == "all") {
         this.searchEl.hidden = false;
         this.loadUsers();
      } else {
         this.searchEl.hidden = true;
         this.loadRequests();
      }
   }

   // =====================================================================
   //  ALL USERS
   // =====================================================================
   async loadUsers() {
      // temp
      // this.users = TEST_USERS;
      // this.renderUsers();
      // return;

      this.rowsEl.innerHTML = `<tr><td colspan="5">Loading...</td></tr>`;
      try {
         const res = await api("/admin/users");
         if (!res.ok) throw new Error(String(res.status));
         this.users = await res.json();
         this.renderUsers();
      } catch (err) {
         this.rowsEl.innerHTML = `<tr><td colspan="5">Couldn't load users: ${err.message}</td></tr>`;
      }
   }

   visibleUsers() {
      if (!this.filter) return this.users;
      const q = this.filter;
      return this.users.filter((u) => {
         return `${u.name ?? ""} ${u.nickname ?? ""} ${u.email ?? ""}`
            .toLowerCase()
            .includes(q);
      });
   }

   renderUsers() {
      this.setCols(["24%", "14%", "26%", "10%", "16%", "10%"]);
      this.headEl.innerHTML = `
         <tr>
            <th>User Name</th><th>Nickname</th><th>Email</th><th>Classes</th><th>Role</th><th></th>
         </tr>`;
      
      const rows = this.visibleUsers();
      if (!rows.length) {
         this.rowsEl.innerHTML = `<tr><td colspan="6" class="msg">No matching users.</td></tr>`;
         return;
      }

      const roles = ["student", "professor", "admin"];
      this.rowsEl.innerHTML = rows
         .map((u) => {
            const current = u.pendingRole ?? u.role;
            const dirty = u.pendingRole && u.pendingRole !== u.role;
            const options = roles
               .map((r) => `<option value="${r}"${r === current ? " selected" : ""}>${r}</option>`)
               .join("");
            return `
               <tr>
                  <td class="u-name">${this.esc(u.name ?? "-")}</td>
                  <td class="u-nick-name">${this.esc(u.nickname ?? "—")}</td>
                  <td class="u-email">${this.esc(u.email ?? "—")}</td>
                  <td class="u-classes">${u.classes ?? 0}</td>
                  <td><select data-role-for="${u.id}">${options}</select></td>
                  <td class="u-action">
                     <button data-save="${u.id}"${dirty ? "" : " disabled"}>Save</button>
                  </td>
               </tr>`;
         }).join("");
   }

   async saveRole(id, btn) {
      const user = this.users.find((u) => String(u.id) === String(id));
      if (!user || !user.pendingRole) return;
      btn.disabled = true;
      btn.textContent = "Saving...";
      try {
         const res = await api(`/admin/users/${id}/role`, {
            method: "PATCH",
            body: JSON.stringify({ role: user.pendingRole }),
         });
         if (!res.ok) throw new Error(String(res.status));
         user.role = user.pendingRole;
         delete user.pendingRole;
         this.renderUsers();
      } catch (err) {
         btn.disabled = false;
         btn.textContent = "Retry";
         console.error("Save failed:", err.message);
      }
   }

   // =====================================================================
   //  WAITING LIST
   // =====================================================================
   async loadRequests() {
      this.setLoading();
      try {
         const res = await api("/auth/requests");
         if (!res.ok) throw new Error(String(res.status));
         const data = await res.json();
         this.requests = data.request ?? [];
         this.renderRequests();
         this.updateCount(this.requests.length);
      } catch (err) {
         this.setError(`Couldn't load requests: ${err.message}`);
      }
   }

   renderRequests() {
      this.setCols(["50%", "25%", "25%"]);
      this.headEl.innerHTML = `
         <tr>
            <th>Email</th><th>Requested</th><th class="col-actions"></th>
         </tr>`;
      
      if (!this.requests.length) {
         this.rowsEl.innerHTML = `<tr><td colspan="3" class="msg">No pending requests.</td></tr>`;
         return;
      }

      this.rowsEl.innerHTML = this.requests.map((r) => `
         <tr data-req-email="${this.esc(r.email)}">
            <td class="u-email">${this.esc(r.email)}</td>
            <td class="u-requested">${this.fmtDate(r.requested_at)}</td>
            <td class="u-action wait-action">
               <button class="btn-approve" data-approve="${this.esc(r.email)}">Approve</button>
               <button class="btn-deny" data-deny="${this.esc(r.email)}">Deny</button>
            </td>
         </tr>`).join("");
   }

   async approve(email, btn) {
      const row = btn.closest("tr");
      this.setRowBusy(row, "Approving...");
      try {
         const res = await api("/auth/approve", {
            method: "POST",
            body: JSON.stringify({ email }),
         });
         if (!res.ok) throw new Error(String(res.status));
         this.removeRequest(email);
      } catch (err) {
         this.setRowError(row, err.message);
         console.error("Approve failed:", err.message);
      }
   }

   async deny(email, btn) {
      const row = btn.closest("tr");
      this.setRowBusy(row, "Denying...");
      try {
         const res = await api("/auth/deny", {
            method: "POST",
            body: JSON.stringify({ email }),
         });
         if (!res.ok) throw new Error(String(res.status));
         this.removeRequest(email);
      } catch (err) {
         this.setRowError(row, err.message);
         console.error("Deny failed:", err.message);
      }
   }

   // Drop a handled request from the list and re-render
   removeRequest(email) {
      this.requests = this.requests.filter((r) => r.email !== email);
      this.renderRequests();
      this.updateCount(this.requests.length);
   }

   // =====================================================================
   //  SHARED HELPERS
   // =====================================================================
   setLoading() {
      this.headEl.innerHTML = "";
      this.rowsEl.innerHTML = `<tr><td class="msg">Loading…</td></tr>`;
   }
 
   setError(text) {
      this.headEl.innerHTML = "";
      this.rowsEl.innerHTML = `<tr><td class="msg">${this.esc(text)}</td></tr>`;
   }
 
   setRowBusy(row, label) {
      if (!row) return;
      row.querySelectorAll("button").forEach((b) => (b.disabled = true));
      const first = row.querySelector("button");
      if (first) first.textContent = label;
   }
 
   setRowError(row, msg) {
      if (!row) return;
      row.querySelectorAll("button").forEach((b) => (b.disabled = false));
      const approve = row.querySelector("[data-approve]");
      if (approve) approve.textContent = "Retry";
   }

   setCols(widths) {
      const cols = widths.map((w) => `<col style="width: ${w}">`).join("");
      this.colEls.forEach((cg) => (cg.innerHTML = cols));
   }

   // Fetch the waiting count once on load so the tab badge is accurate
   // even before the user opens the Waiting tab.
   async refreshCount() {
      try {
         const res = await api("/auth/requests");
         if (!res.ok) return;
         const data = await res.json();
         this.updateCount((data.request ?? []).length);
      } catch { /* badge is best-effort */ }
   }
 
   updateCount(n) {
      if (!this.countEl) return;
      if (n > 0) {
         this.countEl.textContent = n;
         this.countEl.hidden = false;
      } else {
         this.countEl.hidden = true;
      }
   }
 
   fmtDate(iso) {
      if (!iso) return "—";
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return "—";
      return d.toLocaleString(undefined, {
         month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
      });
   }

   esc(s) {
      return String(s).replace(/[&<>"]/g, (c) =>
         ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c])
      );
   }
}

customElements.define("app-roles", Roles);